import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { insights } from "@/data/insights";

export const Insights = () => {
  const categories = useMemo(() => {
    const set = new Set(insights.map((i) => i.category));
    return ["Ver todos", ...Array.from(set)];
  }, []);

  const [active, setActive] = useState("Ver todos");

  const filtered =
    active === "Ver todos"
      ? insights
      : insights.filter((i) => i.category === active);

  return (
    <section
      id="insights"
      data-testid="insights-section"
      className="bg-white py-28 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-end mb-16 md:mb-20">
          <div className="lg:col-span-7 reveal">
            <div className="flex items-center gap-4 mb-8">
              <span className="rule-yellow" />
              <span className="eyebrow">Conteúdos · Insights editoriais</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-[3.6rem] leading-[1.05] text-[#0a0a0a]">
              Direção editorial da Academy.
              <br />
              <em className="italic">Inteligência aplicada ao salão.</em>
            </h2>
          </div>
          <div className="lg:col-span-5 reveal">
            <p className="text-base md:text-lg leading-relaxed text-[#3a3a3a] max-w-md lg:ml-auto">
              Textos curtos, técnicos e estratégicos sobre o que está
              realmente mudando no comportamento da cliente, no método do
              salão e na direção do negócio.
            </p>
          </div>
        </div>

        {/* Pill chip filter — Osklen-grade geometric form */}
        <div
          data-testid="insights-filter"
          className="mb-16 md:mb-20 flex flex-wrap gap-2.5 md:gap-3 reveal"
          role="tablist"
          aria-label="Filtrar insights por categoria"
        >
          {categories.map((cat) => (
            <button
              key={cat}
              type="button"
              role="tab"
              aria-selected={active === cat}
              data-testid={`insights-pill-${cat.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => setActive(cat)}
              className={`pill-chip ${active === cat ? "is-active" : ""}`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#e5e2db] border border-[#e5e2db]">
          {filtered.map((item, idx) => (
            <Link
              key={item.slug}
              to={`/insights/${item.slug}`}
              data-testid={`insight-card-${item.slug}`}
              className={`group bg-white p-10 md:p-12 editorial-card flex flex-col ${
                idx === 0 && active === "Ver todos"
                  ? "lg:col-span-2 lg:row-span-2 bg-[#fafaf7]"
                  : ""
              }`}
              style={{ transitionDelay: `${idx * 50}ms` }}
            >
              <div className="flex items-start justify-between mb-10">
                <span className="eyebrow text-[#7a5a00]">{item.category}</span>
                <span className="font-display text-2xl text-[#0a0a0a]/30 group-hover:text-[#f2b705] transition-colors">
                  {item.number}
                </span>
              </div>

              <h3
                className={`font-display leading-tight text-[#0a0a0a] mb-5 ${
                  idx === 0 && active === "Ver todos"
                    ? "text-3xl md:text-5xl lg:text-[3.4rem]"
                    : "text-2xl md:text-3xl"
                }`}
              >
                {item.title}
              </h3>
              <p
                className={`text-[#3a3a3a] mb-10 leading-relaxed ${
                  idx === 0 && active === "Ver todos"
                    ? "text-base md:text-lg max-w-xl"
                    : "text-[15px]"
                }`}
              >
                {item.subtitle}
              </p>

              <div className="mt-auto flex items-center justify-between pt-8 border-t border-[#e5e2db]">
                <span className="text-[12px] tracking-[0.18em] uppercase text-[#6b6b6b]">
                  {item.readingTime}
                </span>
                <span className="inline-flex items-center gap-2 text-[12px] tracking-[0.18em] uppercase font-semibold text-[#0a0a0a]">
                  Ler artigo
                  <span
                    aria-hidden
                    className="inline-block transition-transform group-hover:translate-x-1"
                  >
                    →
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
